export default {
    'belgique': 'België',
    'germany': 'Duitsland',
    'france': 'Frankrijk',
    'nederland': 'Nederland',
    'spain': 'Spanje',
}
